import { COMPREHENSION_MEASURE } from '../../constants/measure';
import { FORMS_DATA_FETCH_RETRY } from './apiRetryGetConstants';
import selectors from '../../rootSelectors';
import * as AMA from './amaActions';

export const SET_FORM = 'SET_FORM';
export const CLEAR_FORM = 'CLEAR_FORM';
export const FORMS_FETCH_COMPLETED = 'FORMS_FETCH_COMPLETED';
export const REFRESH_FORMS = 'REFRESH_FORMS';

export const setForm = (form) => ({
    type: SET_FORM,
    form
});

export const clearForm = (formId) => ({
    type: CLEAR_FORM,
    formId,
});

export const formsFetchCompleted = () => ({
    type: FORMS_FETCH_COMPLETED,
});

export const refreshForms = () => ({
    type: REFRESH_FORMS,
});

const fetchMeasureForms = (studentId, period, measureData, action) => (dispatch) => {
    return Promise.all(measureData.map(({measure, secure}) => dispatch(AMA.fetchNextFormId(studentId, period, measure, secure, action, setForm))))
        .then(() => {
            dispatch(formsFetchCompleted());
        });
};

export const fetchStudentForms = () => (dispatch, getStore) => {
    const state = getStore();
    const activeMeasures = selectors.getActiveObsMeasures(state);
    const activeSecureMeasures = selectors.getActiveSecureObsMeasures(state);
    const studentId = selectors.getUserId(state);
    const period = selectors.getToy(state);

    const measureData = [];

    Object.values(COMPREHENSION_MEASURE).forEach(measure => {
        if (activeMeasures.includes(measure)) {
            measureData.push({
                measure,
                secure: activeSecureMeasures.includes(measure)
            });
        }
    });

    if (measureData.length > 0) {
        return dispatch(fetchMeasureForms(
            studentId,
            period,
            measureData,
            FORMS_DATA_FETCH_RETRY,
        ));
    }

    dispatch(formsFetchCompleted());
    return Promise.resolve();
};
